import DateTimePicker from "@common/DateTime";
import Input from "@common/Input";
import Select from "@common/Select";
import TextArea from "@common/TextArea";
import Radio from "@common/Radio";
import ImagePicker from "@common/Image";
import CheckBox from "@common/CheckBox";
import Button from "@common/Button";
import DatePicker_ from "@common/Date";
import SelectSearch from "@common/SelectSearch";
import Tagsinput_ from "@common/TagsInput";
import CreatableSelect from "@common/CreatableSelect";
import GooglePlaces from "@common/GooglePlaces";
import PhoneNumber from "@common/PhoneNumber";
import InputNumber from "common/InputNumber";
 
const FormFields = ({ Fields = [] }) => {
  return (
    <>
      {Fields?.map((e, i) => {
        switch (e.type) {
          case "text":
          case "password":
          case "email":
          case "tel":
            return <Input {...e} key={i} />;
          
          case "number":
            return <InputNumber {...e} key={i}/>

          case "phone_number":
            return <PhoneNumber {...e} key={i} />;

          case "tagInput":
            return <Tagsinput_ {...e} key={i}/>

          case "select_search":
            return <SelectSearch {...e} key={i} />;

          case "select_create":
            return <CreatableSelect {...e} key={i} />;

          case "checkbox":
            return <CheckBox {...e} key={i} />;

          case "radio":
            return <Radio {...e} key={i} />;

          case "select":
            return <Select {...e} key={i} />;

          case "textArea":
            return <TextArea {...e} key={i} />;

          case "datePicker":
            return <DatePicker_ {...e} key={i} />;

          case "dateTimePicker":
            return <DateTimePicker {...e} key={i} />;

          case "image":
            return <ImagePicker {...e} key={i} />;

          case "button":
            return <Button {...e} key={i} />;
          
          case "places":
            return <GooglePlaces {...e} key={i} />;

          default:
            return "";
        }
      })}
    </>
  );
};

export default FormFields;
